const IMAGES = {
  backgroundCadastro: "https://statics.coperdia.com.br/portal_colaborador/img/background_login.png",
  recuperacaoSenha: "https://statics.coperdia.com.br/portal_colaborador/img/recuperar_senha.png",
  logoWhite: "https://statics.coperdia.com.br/portal_colaborador/img/logo-coperdia-white.png",
  logoBlack: "https://statics.coperdia.com.br/portal_colaborador/img/logo-coperdia.png",
  doisFatores: "https://statics.coperdia.com.br/portal_colaborador/img/dois_fatores.png",
};

export { IMAGES };
